import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import i18n from "./i18n";
import MainLayout from "../components/layouts/MainLayout.vue";
import Home from "../components/pages/home/Home.main.vue";
import AcceptInvitation from "../components/pages/AcceptInvitation.vue";
import CompanyProfile from "../components/pages/company_profile/CompanyProfile.main.vue";
import Landing from "../components/pages/landing/Landing.vue";
import Partners from "../components/pages/partners/Partners.vue";
import Product from "../components/pages/product/Product.vue";
import Products from "../components/pages/product/Products.vue";
import ProductGroups from "../components/pages/ProductGroups.vue";
import ProformaInvoices from "../components/pages/proforma_invoice/ProformaInvoices.vue";
import Shipment from "../components/pages/shipment/Shipment.vue";
import Shipments from "../components/pages/shipment/Shipments.vue";
import Subscription from "../components/pages/finance/Subscription.vue";
import UserProfile from "../components/pages/UserProfile.vue";
import SignIn from "../components/pages/SignIn.vue";
import SignUp from "../components/pages/SignUp.vue";
import Error404 from "../components/pages/404.vue";
import ProformaInvoice from "../components/pages/proforma_invoice/ProformaInvoice.vue";
import Contact from "../components/pages/landing/pages/Contact.vue";
import PdfFeature from "../components/pages/landing/pages/PdfFeature.vue";
import BenefitsFeature from "../components/pages/landing/pages/BenefitsFeature.vue";
import StockFeature from "../components/pages/landing/pages/StockFeature.vue";
import TrackingFeature from "../components/pages/landing/pages/TrackingFeature.vue";
import Stocks from "../components/pages/stocks/Stocks.vue";
import Stock from "../components/pages/stocks/Stock.vue";

Vue.use(VueRouter);

const SITE_NAME = "Antrego";

export const necessity = {
	required: 1,
	notRequired: 0,
	notAllowed: -1,
};

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: "smooth",
			};
		}
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: "/",
			name: "landing",
			component: Landing,
			meta: { title: "landing_page" },
		},
		{
			path: "/contact",
			name: "contact",
			component: Contact,
			meta: { title: "contact" },
		},
		{
			path: "/pdf_feature",
			name: "pdf_feature",
			component: PdfFeature,
			meta: { title: "pdf_feature" },
		},
		{
			path: "/stock_feature",
			name: "stock_feature",
			component: StockFeature,
			meta: { title: "stock_feature" },
		},
		{
			path: "/benefits_feature",
			name: "benefits_feature",
			component: BenefitsFeature,
			meta: { title: "benefits_feature" },
		},
		{
			path: "/tracking_feature",
			name: "tracking_feature",
			component: TrackingFeature,
			meta: { title: "tracking_feature" },
		},
		{
			path: "/signin",
			name: "signin",
			component: SignIn,
			meta: { title: "sign_in" },
		},
		{
			path: "/signup",
			name: "signup",
			component: SignUp,
			meta: { title: "sign_up" },
		},
		{
			path: "/accept_invitation/:type",
			name: "accept_invitation",
			component: AcceptInvitation,
			meta: { title: "accept_invitation" },
		},
		{
			path: "",
			component: MainLayout,
			children: [
				{
					path: "/home",
					name: "home",
					component: Home,
					meta: { title: "home" },
				},
				{
					path: "/company_profile",
					name: "companyProfile",
					component: CompanyProfile,
					meta: { title: "company_profile" },
				},
				{
					path: "/partners",
					name: "partners",
					component: Partners,
					meta: { title: "partners" },
				},
				{
					path: "/products",
					name: "products",
					component: Products,
					meta: { title: "products" },
				},
				{
					path: "/products/:id",
					name: "product",
					component: Product,
					meta: { title: "product_details" },
				},
				{
					path: "/product_groups",
					name: "productGroups",
					component: ProductGroups,
					meta: { title: "product_groups" },
				},
				{
					path: "/proforma_invoices",
					name: "proformaInvoices",
					component: ProformaInvoices,
					meta: { title: "proforma_invoices" },
				},
				{
					path: "/shipments",
					name: "shipments",
					component: Shipments,
					meta: { title: "shipments" },
				},
				{
					path: "/shipment/:id",
					name: "shipment",
					component: Shipment,
					meta: { title: "shipment_details" },
				},
				{
					path: "/proforma_invoices/:id",
					name: "proforma_invoice",
					component: ProformaInvoice,
					meta: { title: "proforma_invoices" },
				},
				{
					path: "/subscription",
					name: "subscription",
					component: Subscription,
					meta: { title: "subscription" },
				},
				{
					path: "/user_profile",
					name: "userProfile",
					component: UserProfile,
					meta: { title: "user_profile" },
				},
				{
					path: "/stocks",
					name: "stocks",
					component: Stocks,
					meta: { title: "stocks" },
				},
				{
					path: "/stock/:id",
					name: "stock",
					component: Stock,
					meta: { title: "stock_details" },
				},
			],
		},
		{
			path: "/:publicUrl/:stockId",
			name: "publicStockDetails",
			component: () => import("../components/pages/public/PublicBatches.vue"),
			meta: { title: "stock_details" },
		},
		{
			path: "/:publicUrl",
			name: "publicStocks",
			component: () => import("../components/pages/public/PublicStocks.vue"),
			meta: { title: "stocks" },
		},
		{
			// Always leave this as last one
			path: "*",
			name: "404",
			component: Error404,
			meta: { title: "not_found_page_message" },
		},
	],
});

export function requiresAuthorization(pageName) {
	if (["signin", "/signin", "signup", "/signup"].includes(pageName)) return necessity.notAllowed;
	else if (
		[
			"/",
			"",
			"home",
			"404",
			"accept_invitation",
			"landing",
			"contact",
			"pdf_feature",
			"stock_feature",
			"benefits_feature",
			"tracking_feature",
			"publicStocks",
			"publicStockDetails",
		].includes(pageName)
	)
		return necessity.notRequired;
	else return necessity.required;
}

export function requiresCompany(pageName) {
	if (
		["products", "/products", "product_groups", "/product_groups", "proforma_invoices", "/proforma_invoices"].includes(
			pageName
		)
	)
		return necessity.required;
	else return necessity.notRequired;
}

router.beforeEach((to, from, next) => {
	if (store.getters.isReady) {
		const isAuthenticated = store.getters["auth/isAuthenticated"];
		const company = store.getters["company"];
		if (requiresAuthorization(to.name) === necessity.required && !isAuthenticated) {
			next("/signin");
		} else if (requiresAuthorization(to.name) === necessity.notAllowed && isAuthenticated) {
			next("/");
		} else if (requiresCompany(to.name) === necessity.required && !company) next("/");
		else next();
	} else next();

	const customTitles = ["contact"];

	const seoTitles = {
		landing_page: i18n.t("$seoTitles.landing_page"),
		stock_feature: i18n.t("$seoTitles.stock_feature"),
		tracking_feature: i18n.t("$seoTitles.tracking_feature"),
		pdf_feature: i18n.t("$seoTitles.pdf_feature"),
		benefits_feature: i18n.t("$seoTitles.benefits_feature"),
	};

	if (to.meta.title) {
		if (seoTitles[to.meta.title]) {
			document.title = seoTitles[to.meta.title];
		} else {
			const titleKey = customTitles.includes(to.meta.title) ? to.meta.title : `$pageTitles.${to.meta.title}`;
			document.title = `${SITE_NAME} | ${i18n.t(titleKey)}`;
		}
	} else {
		document.title = `${SITE_NAME}`;
	}

	const descriptionKey = `$pageDescriptions.${to.meta.title}`;
	const description = i18n.te(descriptionKey) ? i18n.t(descriptionKey) : i18n.t("$pageDescriptions.landing_page");

	let metaDescription = document.querySelector('meta[name="description"]');
	if (metaDescription) {
		metaDescription.setAttribute("content", description);
	} else {
		metaDescription = document.createElement("meta");
		metaDescription.name = "description";
		metaDescription.content = description;
		document.head.appendChild(metaDescription);
	}

	let ogDescription = document.querySelector('meta[property="og:description"]');
	if (ogDescription) {
		ogDescription.setAttribute("content", description);
	}

	let twitterDescription = document.querySelector('meta[name="twitter:description"]');
	if (twitterDescription) {
		twitterDescription.setAttribute("content", description);
	}

	let ogTitle = document.querySelector('meta[property="og:title"]');
	if (ogTitle && to.meta.title) {
		const pageTitle = customTitles.includes(to.meta.title)
			? i18n.t(to.meta.title)
			: i18n.t(`$pageTitles.${to.meta.title}`);
		ogTitle.setAttribute("content", `${SITE_NAME} - ${pageTitle}`);
	}

	let twitterTitle = document.querySelector('meta[name="twitter:title"]');
	if (twitterTitle && to.meta.title) {
		const pageTitle = customTitles.includes(to.meta.title)
			? i18n.t(to.meta.title)
			: i18n.t(`$pageTitles.${to.meta.title}`);
		twitterTitle.setAttribute("content", `${SITE_NAME} - ${pageTitle}`);
	}

	let canonical = document.querySelector('link[rel="canonical"]');
	if (canonical) {
		canonical.setAttribute("href", `https://antrego.net${to.path}`);
	}
});

export default router;
